import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { Icon } from "@iconify/react";

import { UserContext } from "../../App";
import { getNavVisibility } from "../../services/rbacService";

const MenuContent = () => {
  const currentUser = useContext(UserContext)?.saccoUser;
  const nav = getNavVisibility(currentUser);
  const {
    showFullMatatuNav,
    isParcelAdminNav,
    isParcelBasicNav,
    showParcelServiceNav,
    showOperatorsNav,
    showSaccoMgmtDropdown,
    showSaccoRegistrationNav,
    showSaccoTeamNav,
    showSaccoFinancesNav,
    showWalletTransactionsNav,
    showStageCollectionsNav,
    showSaccoProfileNav,
    showDashboardNav,
    showCrewWithdrawNav,
    showCrewSavingsNav,
    showCrewLoansNav,
  } = nav;

  const showStandardSaccoMgmtDropdown =
    showSaccoRegistrationNav || showSaccoTeamNav || showSaccoFinancesNav;

  const saccoManagementDropdown = showSaccoMgmtDropdown ? (
    <li className="nav-item dropdown">
      <NavLink
        className="nav-link dropdown-toggle arrow-none"
        to="#"
        id="topnav-sacco"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <Icon icon="charm:apps" className="mr-1 mb-1" />
        Sacco Management <div className="arrow-down"></div>
      </NavLink>
      <div className="dropdown-menu" aria-labelledby="topnav-sacco">

        {showStandardSaccoMgmtDropdown ? (
          <>
            {showSaccoRegistrationNav ? (
              <NavLink
                className="dropdown-item"
                data-toggle="collapse"
                data-target="#topnav-menu-content"
                to="sacco/registration"
              >
                <Icon icon="uil:moneybag" className="mr-1 mb-1" />
                Sacco Registration
              </NavLink>
            ) : null}
            {showSaccoTeamNav ? (
              <NavLink
                className="dropdown-item"
                to="sacco/team"
                data-toggle="collapse"
                data-target="#topnav-menu-content"
              >
                <Icon icon="charm:apps" className="mr-1 mb-1" />
                User Manager
              </NavLink>
            ) : null}
            {showSaccoFinancesNav ? (
              <NavLink
                className="dropdown-item"
                to="sacco/finances"
                data-toggle="collapse"
                data-target="#topnav-menu-content"
              >
                <Icon icon="charm:apps" className="mr-1 mb-1" />
                Finances
              </NavLink>
            ) : null}
          </>
        ) : null}
        {showWalletTransactionsNav ? (
          <NavLink
            className="dropdown-item"
            data-toggle="collapse"
            data-target="#topnav-menu-content"
            to="sacco/wallet-transactions"
          >
            <Icon icon="uil:money-withdrawal" className="mr-1 mb-1" />
            Wallet Transactions
          </NavLink>
        ) : null}
        {showStageCollectionsNav ? (
          <NavLink
            className="dropdown-item"
            data-toggle="collapse"
            data-target="#topnav-menu-content"
            to="sacco/stage-collections"
          >
            <Icon icon="mdi:bus-stop-uncovered" className="mr-1 mb-1" />
            Stage Collections
          </NavLink>
        ) : null}
        {showSaccoProfileNav ? (
          <NavLink
            className="dropdown-item"
            data-toggle="collapse"
            data-target="#topnav-menu-content"
            to="sacco/profile"
          >
            <Icon icon="uil:building" className="mr-1 mb-1" />
            Sacco Profile
          </NavLink>
        ) : null}
      </div>
    </li>
  ) : null;

  return (
    <div className="topnav" style={{ backgroundColor: "#313a46" }}>
      <div className="container-fluid">
        <nav className="navbar navbar-dark navbar-expand-lg topnav-menu">
          <div className="collapse navbar-collapse" id="topnav-menu-content">
            <ul className="navbar-nav dondaa-dash-nav">
              {showFullMatatuNav ? (
                <>
                  <li
                    className="nav-item"
                    data-toggle="collapse"
                    data-target="#topnav-menu-content"
                  >
                    <NavLink
                      className="nav-link dropdown-toggle arrow-none"
                      to=""
                    >
                      <Icon icon="uil:dashboard" className="mr-1 mb-1" />
                      Dashboard
                    </NavLink>
                  </li>
                  {/* <li
                    className="nav-item"
                    data-toggle="collapse"
                    data-target="#topnav-menu-content"
                  >
                    <NavLink
                      className="nav-link dropdown-toggle arrow-none"
                      to="farechart"
                    >
                      <Icon icon="charm:apps" className="mr-1 mb-1" />
                      FareChart
                    </NavLink>
                  </li> */}
                  <li
                    className="nav-item dropdown"
                    data-toggle="collapse"
                    data-target="#topnav-menu-content"
                  >
                    <NavLink className="nav-link arrow-none" to="transactions">
                      <Icon icon="charm:apps" className="mr-1 mb-1" />
                      Transactions
                    </NavLink>
                  </li>
                  {/* <li
                    className="nav-item dropdown"
                    data-toggle="collapse"
                    data-target="#topnav-menu-content"
                  >
                    <NavLink className="nav-link arrow-none" to="crew-manager">
                      <Icon icon="charm:apps" className="mr-1 mb-1" />
                      Crew Manager
                    </NavLink>
                       <div className="dropdown-menu show" aria-labelledby="topnav-dashboards" data-bs-popper="static">
                                        <a href="dashboard-analytics.html" className="dropdown-item">Analytics</a>
                                        <a href="index.html" className="dropdown-item">Ecommerce</a>
                                        <a href="dashboard-projects.html" className="dropdown-item">Projects</a>
                                        <a href="dashboard-crm.html" className="dropdown-item">CRM</a>
                                        <a href="dashboard-wallet.html" className="dropdown-item">E-Wallet</a>
                                    </div>
                  </li> */}
                  <li
                    className="nav-item"
                    data-toggle="collapse"
                    data-target="#topnav-menu-content"
                  >
                    <NavLink
                      className="nav-link dropdown-toggle arrow-none"
                      to="matatu"
                    >
                      <Icon
                        icon="fluent:vehicle-bus-20-filled"
                        className="mr-1 mb-1"
                      />
                      Matatu
                    </NavLink>
                  </li>
                  <li
                    className="nav-item"
                    data-toggle="collapse"
                    data-target="#topnav-menu-content"
                  >
                    <NavLink
                      className="nav-link dropdown-toggle arrow-none"
                      to="parcel-service"
                    >
                      <Icon
                        icon="fluent:vehicle-bus-20-filled"
                        className="mr-1 mb-1"
                      />
                      Parcel Service
                    </NavLink>
                  </li>

                  <li className="nav-item dropdown">
                    <NavLink
                      className="nav-link dropdown-toggle arrow-none"
                      to="#"
                      id="topnav-crew"
                      // role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <Icon icon="charm:apps" className="mr-1 mb-1" />
                      Crew <div className="arrow-down"></div>
                    </NavLink>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="topnav-crew"
                    >
                      <NavLink
                        className="dropdown-item"
                        to="crew-manager"
                        data-toggle="collapse"
                        data-target="#topnav-menu-content"
                      >
                        <Icon icon="charm:apps" className="mr-1 mb-1" />
                        Crew Manager
                      </NavLink>
                      {showCrewWithdrawNav ? (
                        <NavLink
                          className="dropdown-item"
                          data-toggle="collapse"
                          data-target="#topnav-menu-content"
                          to="withdraw"
                        >
                          <Icon
                            icon="uil:money-insert"
                            className="mr-1 mb-1"
                          />
                          Withdraw
                        </NavLink>
                      ) : null}
                      {showCrewSavingsNav ? (
                        <NavLink
                          className="dropdown-item"
                          data-toggle="collapse"
                          data-target="#topnav-menu-content"
                          to="savings"
                        >
                          <Icon
                            icon="uil:money-insert"
                            className="mr-1 mb-1"
                          />
                          Savings
                        </NavLink>
                      ) : null}
                      {showCrewLoansNav ? (
                        <NavLink
                          className="dropdown-item"
                          data-toggle="collapse"
                          data-target="#topnav-menu-content"
                          to="loans"
                        >
                          <Icon icon="uil:moneybag" className="mr-1 mb-1" />
                          Loans
                        </NavLink>
                      ) : null}
                    </div>
                  </li>

                  <li
                    className="nav-item"
                    data-toggle="collapse"
                    data-target="#topnav-menu-content"
                  >
                    <NavLink
                      className="nav-link dropdown-toggle arrow-none"
                      to="notifications"
                    >
                      <Icon icon="akar-icons:bell" className="mr-1 mb-1" />
                      {/* <i className="uil-apps mr-1"></i> */}
                      Notifications
                    </NavLink>
                  </li>
                </>
              ) : null}
              {isParcelAdminNav ? (
                <>
                  <li
                    className="nav-item"
                    data-toggle="collapse"
                    data-target="#topnav-menu-content"
                  >
                    <NavLink
                      className="nav-link dropdown-toggle arrow-none"
                      to=""
                    >
                      <Icon icon="uil:dashboard" className="mr-1 mb-1" />
                      Dashboard
                    </NavLink>
                  </li>
                  <li
                    className="nav-item"
                    data-toggle="collapse"
                    data-target="#topnav-menu-content"
                  >
                    <NavLink
                      className="nav-link dropdown-toggle arrow-none"
                      to="parcel-service"
                    >
                      <Icon
                        icon="fluent:vehicle-bus-20-filled"
                        className="mr-1 mb-1"
                      />
                      Parcel Service
                    </NavLink>
                  </li>
                </>
              ) : null}

              {!showFullMatatuNav && !isParcelAdminNav && !isParcelBasicNav && showDashboardNav ? (
                <li
                  className="nav-item"
                  data-toggle="collapse"
                  data-target="#topnav-menu-content"
                >
                  <NavLink className="nav-link dropdown-toggle arrow-none" to="">
                    <Icon icon="uil:dashboard" className="mr-1 mb-1" />
                    Dashboard
                  </NavLink>
                </li>
              ) : null}
              {isParcelBasicNav ? (
                <li
                  className="nav-item"
                  data-toggle="collapse"
                  data-target="#topnav-menu-content"
                >
                  <NavLink
                    className="nav-link dropdown-toggle arrow-none"
                    to="parcel-service"
                  >
                    <Icon
                      icon="fluent:vehicle-bus-20-filled"
                      className="mr-1 mb-1"
                    />
                    Parcel Service
                  </NavLink>
                </li>
              ) : null}
              {showParcelServiceNav ? (
                <li
                  className="nav-item"
                  data-toggle="collapse"
                  data-target="#topnav-menu-content"
                >
                  <NavLink
                    className="nav-link dropdown-toggle arrow-none"
                    to="parcel-service"
                  >
                    <Icon
                      icon="fluent:vehicle-bus-20-filled"
                      className="mr-1 mb-1"
                    />
                    Parcel Service
                  </NavLink>
                </li>
              ) : null}
              {saccoManagementDropdown}
              {showOperatorsNav ? (
                <li
                  className="nav-item dropdown"
                  data-toggle="collapse"
                  data-target="#topnav-menu-content"
                >
                  <NavLink className="nav-link arrow-none" to="operators">
                    <Icon icon="octicon:people-24" className="mr-1 mb-1" />
                    Operators
                  </NavLink>
                </li>
              ) : null}
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MenuContent;
